import React from 'react';
import config from '../../../config';

type Props = {
  phoneNumber: string;
};

const OtpHeader: React.FC<Props> = ({ phoneNumber }) => {
  const logoSrc = `${config.app.baseUrl}assets/images/raaz-logo.png`;
  return (
    <div className="flex flex-col items-center mb-12 sm:mb-14">
      <div className="w-20 h-20 mb-6 relative">
        <div className="absolute inset-0 bg-[#d5b481]/20 rounded-2xl rotate-3"></div>
        <div className="relative w-full h-full bg-white rounded-2xl shadow-md flex items-center justify-center p-3 border border-[#d5b481]/30">
          <img src={logoSrc} alt="راز گلد" className="w-full h-full object-contain" />
        </div>
      </div>
      <h2 id="otp-title" className="text-2xl font-black text-[#0e444e] mb-2">تایید شماره موبایل</h2>
      <div className="flex items-center gap-2 text-sm font-medium text-gray-500 bg-gray-50 px-3 py-1 rounded-lg border border-gray-100">
        <span>ارسال شده به:</span>
        <span className="text-[#0e444e] font-bold tracking-wider" dir="ltr">{phoneNumber}</span>
      </div>
    </div>
  );
};

export default OtpHeader;
